<script setup lang="ts">
import { computed } from "vue";
import { useSelector } from "@xstate/vue";

import Loading from "@/components/Loading.vue";

import { authMachine } from "@/machines/auth-machine";
import { recordReload } from "@/services/ReloadDiagnostics";
import { getAuthErrorMessage, getAuthStateMessage } from "@recordsure/unity-auth-machine";

const code = useSelector(authMachine, (state) => state.context.error);
const isSettled = useSelector(authMachine, (state) => state.hasTag("Settled"));
const isTokenRevoked = useSelector(authMachine, (state) => state.context.tokenRevoked);
const isAuthenticated = useSelector(authMachine, (state) => state.matches("authenticated"));

const errorMessage = computed(() => {
  if (code.value == null) return getAuthStateMessage(isAuthenticated.value);
  return getAuthErrorMessage(code.value);
});

function runAction() {
  if (isAuthenticated.value) {
    recordReload("authenticated-home-navigation");
    window.location.pathname = "/";
  } else authMachine.send({ type: "LOGIN", path: null });
}
</script>
<template>
  <div class="tw-grid tw-h-full tw-place-items-center tw-overflow-auto">
    <form v-if="isSettled" class="tw-flex tw-max-w-sm tw-flex-col tw-items-center tw-gap-2" @submit.prevent="runAction">
      <div
        v-if="isTokenRevoked === false"
        class="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-orange-500 tw-bg-orange-200/20 tw-p-4 tw-shadow"
      >
        <h5 class="tw-font-semibold tw-tracking-wide">Authentication Error:</h5>
        <p class="tw-text-xs">Error revoking auth tokens.</p>
      </div>
      <img src="/logo-header.png" alt="Recordsure Logo" class="tw-h-20 tw-w-20" />
      <h4 className="tw-text-3xl tw-font-bold tw-text-center">
        {{ errorMessage.main }}
      </h4>
      <p class="text-lg tw-text-balance tw-text-center">
        {{ errorMessage.content }}
      </p>
      <p v-if="errorMessage.subtitle != null" class="text-lg tw-text-balance tw-text-center">
        {{ errorMessage.subtitle }}
      </p>
      <button
        type="submit"
        :aria-label="isAuthenticated ? 'Go to Brand Home' : 'Click to Log into Recordsure portal'"
        className="tw-flex tw-gap-2 tw-py-2 tw-px-4 tw-rounded-md tw-bg-gray-500 tw-items-center"
      >
        <template v-if="isAuthenticated">
          <i class="fas fa-right-long"></i>
          Go to page
        </template>
        <template v-else>
          <i class="fas fa-sign-in"></i>
          Log In
        </template>
      </button>
    </form>
    <Loading v-else id="loading" message="Authenticating..." />
  </div>
</template>
